import { RequestCache } from './RequestCache'
import { RequestCacheOptions } from '../../Types/Types'

/**
 * This holds and list of the current caches stored by URL and allows you to access them.
 */
export class RequestCacheHandler {
    private caches: { [key: string]: RequestCache } = {}

    /**
     * Get a cache by URL.
     *
     * @param url - The URL to get the cache for.
     * @param options - The options for the cache.
     * @returns - The RequestCache object for the given URL.
     */
    public cacheByURL(url: string, options?: RequestCacheOptions): RequestCache {
        let cache: RequestCache = this.caches[url]

        if (!cache) {
            cache = RequestCache.newInstance(options)
            this.caches[url] = cache
        }

        return cache
    }
}
